import type { ComponentTemplate } from "schemas/generated/componentTemplates";

export const buyWithPrimeButton: ComponentTemplate = {
  id: "d7cfe57d-812e-436a-8c5c-2df0f4684333",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Product/Buy With Prime Button",
  leftBarCategory: { main: "product", subCategory: "buttons" },
  tags: ["product", "widget"],
  preview: "integrations/buy-with-prime-button.svg",
  transforms: [],
  template: {
    id: "$uid",
    type: "buyWithPrimeButton",
    props: { style: { alignSelf: "stretch" } },
  },
};
